import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React, { ReactNode, isValidElement } from 'react';
import ksimUnhappy from '../assets/ksim-unhappy2.png';

export interface ErrorDialogState {
  message?: ReactNode | string;
  open: boolean;
}

export interface ErrorDialogProps extends ErrorDialogState {
  title?: string;
  children: ReactNode;
  transition?: TransitionProps;
}

const ErrorDialog = ({
  title = 'Oh no, something went wrong',
  children,
  message,
  open,
  transition,
}: ErrorDialogProps) => (
  <Dialog open={open} TransitionProps={transition}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent sx={{ display: 'flex', alignItems: 'center', gap: 6, pr: 8 }}>
      <Box>
        {isValidElement(message) ? (
          message
        ) : (
          <DialogContentText color="text.primary" variant="body1">
            {message}
          </DialogContentText>
        )}
      </Box>
      <Box component="img" alt="K-Sim" src={ksimUnhappy} width="193px" />
    </DialogContent>
    <DialogActions>{children}</DialogActions>
  </Dialog>
);

export default ErrorDialog;
